export const FETCH_LEARNINGPATH = 'FETCH_LEARNINGPATH';
export const EMPTY_LEARNINGPATH = 'EMPTY_LEARNINGPATH';
export const START_LEARNINGPATH = 'START_LEARNINGPATH';
export const STARTED_LEARNINGPATH = 'STARTED_LEARNINGPATH';
export const RESET_LEARNINGPATH = 'RESET_LEARNINGPATH';

const getHeaders = (user) => {
    return {
        Authorization: `Bearer ${user.access_token}`,
        'Content-Type': 'application/json',
    };
};

export const fetchLearningPathInfo = (targetId) => async (dispatch, getState) => {
    const {minervaSettings, oidc} = getState();
    const {apiUrl} = minervaSettings;
    const {user} = oidc;

    if (!apiUrl) return;

    if (!targetId || targetId === '') {
        dispatch({
            type: EMPTY_LEARNINGPATH,
        });
        return;
    }

    dispatch({
        type: FETCH_LEARNINGPATH,
        async payload() {
            const learningPathInfoResult = await fetch(
                `${apiUrl}/api/330/learningPathInfo?targetId=${targetId}&idString=${user.profile.idString}`,
                {
                    headers: getHeaders(oidc.user),
                },
            );

            const sLearningPathInfoResult = await learningPathInfoResult.text();

            if (sLearningPathInfoResult) {
                const learningPathInfo = JSON.parse(sLearningPathInfoResult);

                return {
                    ...learningPathInfo,
                };
            }

            return;
        },
    });
};

export const startOrResumeLearningPath = (targetId) => async (dispatch, getState) => {
    const {minervaSettings, oidc} = getState();
    const {apiUrl} = minervaSettings;
    const {user} = oidc;

    dispatch({
        type: START_LEARNINGPATH,
        async payload() {
            const learningPathInfoResult = await fetch(
                `${apiUrl}/api/330/startOrResumeLearningPath`,
                {
                    method: 'POST',
                    headers: getHeaders(user),
                    body: JSON.stringify({
                        targetId: targetId,
                        idString: user.profile.idString,
                    }),
                },
            );

            const sLearningPathInfoResult = await learningPathInfoResult.text();

            if (sLearningPathInfoResult) {
                const learningPathInfo = JSON.parse(sLearningPathInfoResult);

                return {
                    ...learningPathInfo,
                };
            }

            return;
        },
    });
};

export const resetLearningPath = (targetId) => async (dispatch, getState) => {
    const {minervaSettings, oidc} = getState();
    const {apiUrl} = minervaSettings;
    const {user} = oidc;

    await dispatch({
        type: RESET_LEARNINGPATH,
        async payload() {
            await fetch(`${apiUrl}/api/330/restartLearningPath`, {
                method: 'POST',
                headers: getHeaders(user),
                body: JSON.stringify({
                    targetId: targetId,
                    idString: user.profile.idString,
                }),
            });

            return;
        },
    });
};

export const startedLearningPath = () => (dispatch) => {
    dispatch({type: STARTED_LEARNINGPATH});
};
